import SpreadSlider from './spreadSlider'

export default SpreadSlider